import { useQuery } from '@apollo/client';
import { CITRIN_GET_REQUEST_BOOKINGS, GetRequestBookingsRequest, GetRequestBookingsResponse } from '..';
import { useEffect, useRef, useState } from 'react';
import { debounce } from 'lodash';
import { RequestBookingQueryFilterMGT } from '../../shared/types';

export const useGetRequestBookingsQuery = (request: RequestBookingQueryFilterMGT, debounceTime?: number) => {
    const [internalRequest, setInternalRequest] = useState(() => request);
    const debounced = useRef(
        debounce(
            (newRequest: RequestBookingQueryFilterMGT) => {
                setInternalRequest(newRequest);
            },
            debounceTime ?? 100,
            { leading: false, trailing: true }
        )
    ).current;
    useEffect(() => {
        return debounced(request);
    }, [request]);

    const { data, previousData, ...rest } = useQuery<GetRequestBookingsResponse, GetRequestBookingsRequest>(
        CITRIN_GET_REQUEST_BOOKINGS,
        {
            variables: { request: internalRequest },
            // fetchPolicy: 'cache-and-network',
            // onCompleted: (data) => console.log('[MGT] Pricing', data),
        }
    );

    return {
        ...rest,
        previousData: previousData?.CITRIN_MGT_getRequestBookings,
        data: data?.CITRIN_MGT_getRequestBookings ?? [],
    };
};
